import {ObjectUtil} from '../../util/object-util';

export class LineOfBusiness {
  lineOfBusinessId: string = null;
  name: string = null;
  description: string = null;
  number: string = null;

  constructor(object?: any) {
    ObjectUtil.assign(this, object);
  }

}
